import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useLanguage } from '../context/LanguageContext';
import './ProductCard.css';
import AedPrice from './AedPrice';

const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const { t, language } = useLanguage();
  const [showAddedNotification, setShowAddedNotification] = useState(false);

  const isDisabled = product.enabled === false;

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isDisabled) return; // Don't add disabled products
    addItem(product);
    setShowAddedNotification(true);

    // Auto hide after 5 seconds
    setTimeout(() => {
      setShowAddedNotification(false);
    }, 5000);
  };

  // Get product name based on language
  const productName = language === 'ar' && product.nameAr ? product.nameAr : product.name;
  const productCategory = language === 'ar' && product.categoryAr ? product.categoryAr : product.category;

  const formatPrice = (price) => <AedPrice amount={price} />;

  return (
    <Link to={`/products/${product.id}`} className="product-card" style={{ opacity: isDisabled ? 0.7 : 1 }}>
      <div className="product-image">
        {product.hideImage ? (
          <div style={{
            width: '100%',
            height: '100%',
            background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#9ca3af',
            fontSize: '48px'
          }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 002 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
          </div>
        ) : (
          <img src={product.image} alt={productName} />
        )}
        {product.onSale && product.salePrice && !isDisabled && (
          <span className="sale-badge">{language === 'ar' ? 'تخفيض' : 'SALE'}</span>
        )}
        {product.featured && !isDisabled && !product.onSale && <span className="featured-badge">{t('featured')}</span>}
        {isDisabled && (
          <span className="unavailable-badge" style={{
            position: 'absolute',
            top: '10px',
            left: '10px',
            background: '#ef4444',
            color: 'white',
            padding: '4px 12px',
            borderRadius: '20px',
            fontSize: '12px',
            fontWeight: '600'
          }}>
            {language === 'ar' ? 'غير متوفر' : 'Not Available'}
          </span>
        )}
      </div>
      <div className="product-info">
        <span className="product-category">{productCategory}</span>
        <h3 className="product-name">{productName}</h3>
        {product.onSale && product.salePrice ? (
          <div className="product-price" style={{ marginBottom: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span>{formatPrice(product.salePrice)}</span>
              <span style={{ fontWeight: '700', color: '#dc2626' }}>
                -{Math.round((1 - product.salePrice / product.price) * 100)}%
              </span>
            </div>
            <div style={{ fontSize: '12px', fontWeight: '400', color: '#9ca3af', marginTop: '2px' }}>
              {language === 'ar' ? 'كان' : 'Was'}: <span style={{ textDecoration: 'line-through' }}>{formatPrice(product.price)}</span>
            </div>
          </div>
        ) : (
          <p className="product-price">{formatPrice(product.price)}</p>
        )}

        {isDisabled ? (
          <button
            className="btn add-to-cart-btn"
            disabled
            style={{
              background: '#9ca3af',
              cursor: 'not-allowed'
            }}
          >
            {language === 'ar' ? 'غير متوفر حالياً' : 'Currently Unavailable'}
          </button>
        ) : (
          <button
            className={`btn add-to-cart-btn ${showAddedNotification ? 'btn-added' : 'btn-primary'}`}
            onClick={handleAddToCart}
          >
            {showAddedNotification ? `✓ ${t('addedToCart') || 'Added!'}` : t('addToCart')}
          </button>
        )}
      </div>
    </Link>
  );
};

export default ProductCard;
